import api from './api';

export type PlanoAnuidade = 'Caçador Padrão' | 'Caçador Temporada' | 'Caçador Grátis';

export const VALOR_PLANO_PADRAO = 190;
export const VALOR_PLANO_GRATIS = 0;

export interface AnuidadeSocio {
  id: number;
  nome: string;
  codigo: string;
}

export interface Anuidade {
  id?: number;
  socio?: AnuidadeSocio;
  socio_id?: number;
  ano: number;
  data_vencimento: string;
  valor: number;
  plano?: PlanoAnuidade | string | null;
  status?: string;
  data_pagamento?: string | null;
  observacoes?: string;
}

export interface AnuidadeCreate {
  socio_id: number;
  ano: number;
  data_vencimento: string;
  valor: number;
  plano: PlanoAnuidade;
  observacoes?: string;
}

export interface AnuidadeUpdate {
  plano?: PlanoAnuidade;
  ano?: number;
  data_vencimento?: string;
  valor?: number;
  observacoes?: string;
  status?: string;
  data_pagamento?: string | null;
}

export const anuidadeService = {
  async listar(params?: {
    skip?: number;
    limit?: number;
    socio_id?: number;
    ano?: number;
    status?: string;
  }): Promise<Anuidade[]> {
    const response = await api.get<Anuidade[]>('/api/anuidades/', { params });
    return response.data;
  },

  async criar(anuidade: AnuidadeCreate): Promise<Anuidade> {
    const response = await api.post<Anuidade>('/api/anuidades/', anuidade);
    return response.data;
  },

  async atualizar(anuidadeId: number, anuidade: AnuidadeUpdate): Promise<Anuidade> {
    const response = await api.put<Anuidade>(`/api/anuidades/${anuidadeId}`, anuidade);
    return response.data;
  },

  async deletar(anuidadeId: number): Promise<void> {
    await api.delete(`/api/anuidades/${anuidadeId}`);
  },

  async pagar(anuidadeId: number, data_pagamento: string): Promise<Anuidade> {
    const response = await api.patch<Anuidade>(`/api/anuidades/${anuidadeId}/pagar`, {
      data_pagamento,
    });
    return response.data;
  },
};
